import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'nova-error-message',
    imports: [CommonModule, MatIconModule],
    templateUrl: './error-message.component.html',
    styleUrls: ['./error-message.component.scss'],
    standalone: true
})
export class ErrorMessageComponent {
    @Input() errorMessage?: string;
}
